<template>
  <el-date-picker class="h-40" v-model="childValue" type="datetimerange" :placeholder="placeholder" @input="change"></el-date-picker>
</template>

<script>
  export default {
    props: {
      value: '',
      placeholder: ''
    },
    data() {
      return {
        childValue: []
      }
    },
    created() {
      this.initData()
    },
    methods: {
      initData() {
        if (this.value && this.value.length) {
          let startDate = new Date(this.value[0] * 1000)
          let endDate = new Date(this.value[1] * 1000)
          if (this.isTypeDate(startDate) && this.isTypeDate(endDate)) {
            this.childValue = [startDate, endDate]
          }
        }
      },
      isTypeDate (value) {
        return typeof value == 'object' && value.getDate
      },
      change() {
        let startDate = ''
        let endDate = ''
        if (this.childValue[0]) {
          startDate = moment(this.childValue[0]).unix()
        } else {
          startDate = ''
        }
        if (this.childValue[1]) {
          endDate = moment(this.childValue[1]).unix()
        } else {
          endDate = ''
        }
        let dateArr = [startDate, endDate]
        this.$emit('input', dateArr)
      }
    },
    watch: {
      'value' () {
        if (!_g.isRealEmpty(this.value) &&
            this.value.length > 1 &&
            this.value[0] &&
            this.value[1]) {
          this.initData()
        } else {
          this.childValue = []
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// datetimerangeFilter.vue?5a752d4d